import React, { useContext } from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import AboutUs from "./components/AboutUs";
import Contact from "./components/ContactUs";

import { Routes, Route } from "react-router-dom";
import Hero from "./components/Hero";
import Hero2 from "./components/Hero2";
import FacilitiesPage from "./components/FacilitiesPage";

// Import pages
import Services from "./components/Services";
import Doctors from "./components/Doctors";
import DoctorDetails from "./components/DoctorDetails";
import Expertise from "./components/Expertise";
import FAQsPage from "./components/FAQsPage";
import HealthTips from "./components/HealthTips";
import Footer from "./components/Footer";
import Gallery from "./components/Gallery";
import Location from "./components/Location";
import Timings from "./components/Timings";
import SocialBar from "./components/SocialBar";
import LandingServices from "./components/LandingServices";
import ScrollToTop from "./components/ScrollToTop";
import GalleryFp from "./components/GalleryFp";

import { AdminContext } from "./components/AdminContext"; // Admin context
import HospitalStats from "./components/HospitalStats";

function App() {

  // Protected route wrapper for GalleryFp
  const ProtectedGallery = () => {
    const { isAdmin } = useContext(AdminContext); // moved context here

    if (!isAdmin) {
      return (
        <p style={{ textAlign: "center", marginTop: "50px", fontSize: "18px" }}>
          You must be logged in as Admin to view this page.
        </p>
      );
      // Or redirect: return <Navigate to="/" />;
    }

    return <GalleryFp isAdmin={isAdmin} />;
  };

  return (
    <>
      <Navbar />
      <ScrollToTop />

      {/* MAIN ROUTES */}
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Hero2 />
              <Doctors />
              <HospitalStats />
              <LandingServices />
              <Expertise />
              <FacilitiesPage />
              <Gallery /> {/* Homepage gallery remains unchanged */}
              <FAQsPage />
              <HealthTips />
              <Timings />
              <Location />
            </>
          }
        />

        <Route path="/about" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/doctors" element={<Doctors />} />
        <Route path="/doctors/:id" element={<DoctorDetails />} />
        <Route path="/contact" element={<Contact />} />

        {/* Protected admin-only gallery page */}
<Route path="/gallery-full" element={<GalleryFp />} />
      </Routes>

      {/* Footer appears on every page */}
      <Footer />

      {/* FLOATING WHATSAPP BUTTON (OUTSIDE ROUTES ALWAYS) */}
      {/* <WhatsAppButton /> */}
      <SocialBar />
    </>
  );
}

export default App;
